import { useHistory } from "react-router";
import { RequestError } from "../core/api/RequestError";
import { isVerificationRequired } from "../core/api/contracts/User";
import { useAuth } from "../GlobalContext";

/**
 * If we get a VerificationRequired error from the API then redirect the user to the verify email page
 * @returns {(error: RequestError) => boolean}
 */
function useVerificationErrorHandler() {
  const history = useHistory();
  const auth = useAuth();
  return (error: RequestError) => {
    const body = error.response.body;
    if (isVerificationRequired(body)) {
      auth.setAuthentication(false);
      history.push(`/verification-required/${encodeURIComponent(body.verificationEmail)}`);
      return true;
    } else {
      return false;
    }
  };
}
export default useVerificationErrorHandler;
